import React, { useState } from 'react';
import Modal from '@blaze-react/modal';
import VideoRender from './VideoRender';

const VideoModal = ({ ...props }) => {
  const [displayModal, setDisplayModal] = useState(false);

  return (
    <>
      <div
        role="button"
        aria-label="Open video"
        onClick={() => {
          setDisplayModal(!displayModal);
        }}>
        <VideoRender placeholderOnly autoplay={false} {...props} />
      </div>
      {displayModal && (
        <Modal
          className="modal--video"
          isFullScreen
          showFooter={false}
          isSimple
          onClose={() => setDisplayModal(!displayModal)}>
          <VideoRender {...props} placeholderOnly={false} autoplay />
        </Modal>
      )}
    </>
  );
};

export default VideoModal;
